import { sharedTypes } from '../../../lib/api/models/umbraco';
import { getUniqueId } from '../../../utils/helpers';

export function getMediaKey(image: sharedTypes.Image | undefined, video: sharedTypes.Video | undefined, keySuffix?: string): string {
    if (image) {
        return `image:${image.id}`;
    }

    if (video) {
        const suffix = keySuffix ?? '';
        return `video:${video?.id}-${suffix}`;
    }

    return getUniqueId();
}
